import { lazy } from 'react';

// Lazy load page components for route-based code splitting
// Use relative imports with proper file extensions for TypeScript resolution

// Pages with default exports
export const AuthPage = lazy(() => import('../pages/auth/auth.page'));

// Pages with named exports - destructure them properly with type safety
export const HomePage = lazy(() =>
  import('../pages/home.page').then((module: any) => ({
    default: module.HomePage || module.default,
  })),
);

export const DashboardPage = lazy(() =>
  import('../pages/dashboard.page').then((module: any) => ({
    default: module.DashboardPage,
  })),
);

// Features pages
export const FeaturesPage = lazy(() =>
  import('../pages/features/features.page').then((module: any) => ({
    default: module.FeaturesPage || module.default,
  })),
);
export const FeatureEditPage = lazy(() =>
  import('../pages/features/feature/feature.edit').then((module: any) => ({
    default: module.FeatureEditPage || module.default,
  })),
);

// Subscriptions pages
export const SubscriptionsPage = lazy(() =>
  import('../pages/subscriptions/subscriptions.page').then((module: any) => ({
    default: module.SubscriptionsPage || module.default,
  })),
);
export const SubscriptionEditPage = lazy(() =>
  import('../pages/subscriptions/subscription/subscription.edit').then(
    (module: any) => ({
      default: module.SubscriptionEditPage || module.default,
    }),
  ),
);

// Admin pages
export const AdminMarketplacePage = lazy(() =>
  import('../pages/admin/marketplace/marketplace.page').then((module: any) => ({
    default: module.AdminMarketplacePage || module.default,
  })),
);
export const AdminMarketplaceFeaturesPage = lazy(() =>
  import('../pages/admin/marketplace/features.page').then((module: any) => ({
    default: module.AdminMarketplaceFeaturesPage || module.default,
  })),
);

// Tenants pages
export const TenantsPage = lazy(() =>
  import('../pages/tenants/tenants.page').then((module: any) => ({
    default: module.TenantsPage || module.default,
  })),
);
export const TenantEditPage = lazy(() =>
  import('../pages/tenants/tenant/tenant.edit').then((module: any) => ({
    default: module.TenantEditPage || module.default,
  })),
);

// Credits / Revenue / Entitlements pages
export const CreditsPage = lazy(() =>
  import('../pages/credits/credits.page').then((module: any) => ({
    default: module.CreditsPage || module.default,
  })),
);
export const RevenuePage = lazy(() =>
  import('../pages/revenue/revenue.page').then((module: any) => ({
    default: module.RevenuePage || module.default,
  })),
);
export const EntitlementsPage = lazy(() =>
  import('../pages/entitlements/entitlements.page').then((module: any) => ({
    default: module.EntitlementsPage || module.default,
  })),
);

// Error pages
export const NotFoundPage = lazy(() => import('../pages/errors/404.page'));
export const WarningPage = lazy(() => import('../pages/errors/Warning.page'));
export const AccessDeniedPage = lazy(() =>
  import('../pages/errors/AccessDenied.page').then((module: any) => ({
    default: module.AccessDeniedPage || module.default,
  })),
);

// Layout components
export const MainLayout = lazy(() => import('../layouts/mainLayout'));
